export default "__VITE_ASSET__CAQbCS87__"